import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { trackCTAClick } from '../utils/metaPixel';
export function HeroSection() {
  const checkoutUrl = 'https://yennilemon.com/cart/44211058212999:1?country=MX&locale=es-MX';
  return <section className="relative bg-warm-white overflow-hidden pt-6 pb-12 md:py-20 lg:py-24 px-4 md:px-4" data-id="element-132">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-12 items-center" data-id="element-133">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col space-y-3 md:space-y-6" data-id="element-134">
          {/* Mobile headline — max 3 lines, tighter sizing */}
          <h1 className="md:hidden text-[clamp(24px,6.5vw,32px)] font-heading font-bold text-olive leading-[1.2] text-center" data-id="element-135">
            Comes sano, te mueves... ¿y tu abdomen sigue inflamado?
          </h1>
          {/* Desktop headline */}
          <h1 className="hidden md:block text-4xl lg:text-5xl xl:text-6xl font-heading font-bold text-olive leading-tight" data-id="element-136">
            Comes sano, te mueves... ¿y tu abdomen sigue inflamado?
          </h1>

          {/* Subheadline — visible on both mobile and desktop */}
          <p className="text-base md:text-xl text-warm-gray leading-relaxed max-w-xl text-center md:text-left" data-id="element-137">
            El plan práctico para mujeres +40 que desinflama tu cuerpo y
            recupera tu energía sin dietas milagrosas.
          </p>

          {/* Mobile ebook image — scaled to 85% */}
          <div className="md:hidden flex justify-center mt-1" data-id="element-138">
            <img src="https://cdn.magicpatterns.com/uploads/2dDCDgq8yAYwtpqwYtng8M/mockup1.png" alt="Plan Antiinflamatorio Después de los 40 Ebook" className="max-w-[238px] w-[85%] h-auto object-contain drop-shadow-2xl" data-id="element-139" />
          </div>

          {/* Benefit pills — hidden on mobile */}
          <div className="hidden md:flex flex-col gap-3 py-2" data-id="element-140">
            {[{
            icon: '🔥',
            text: 'Activa tu metabolismo sin dietas extremas'
          }, {
            icon: '⚡',
            text: 'Recupera tu energía y equilibrio hormonal'
          }, {
            icon: '📖',
            text: 'Guía práctica con resultados reales'
          }].map((pill, idx) => <div key={idx} className="flex items-center gap-3 bg-cream px-4 py-3 rounded-xl border border-sage/20 w-fit" data-id="element-141">
                <span className="text-xl" data-id="element-142">{pill.icon}</span>
                <span className="text-olive font-medium text-sm md:text-base" data-id="element-143">
                  {pill.text}
                </span>
              </div>)}
          </div>

          {/* Pricing Block */}
          <div className="mt-2 md:mt-4 bg-cream border-2 border-sage rounded-2xl p-5 md:p-8 text-center max-w-md mx-auto lg:mx-0 shadow-soft relative" data-id="element-144">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-sage text-white text-xs font-bold px-4 py-1 rounded-full whitespace-nowrap" data-id="element-145">
              👇 PRECIO DE LANZAMIENTO
            </div>

            <div className="flex flex-col items-center justify-center space-y-1 mt-2" data-id="element-146">
              <div className="flex items-center gap-2 text-warm-gray text-sm" data-id="element-147">
                <span data-id="element-148">Precio regular:</span>
                <span className="line-through decoration-warm-accent/50" data-id="element-149">
                  $497 MXN
                </span>
                <span className="bg-warm-accent text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-150">
                  -75% OFF
                </span>
              </div>

              <div className="text-5xl md:text-6xl font-bold text-olive font-heading py-1 md:py-2" data-id="element-151">
                $114 <span className="text-2xl md:text-3xl" data-id="element-152">MXN</span>
              </div>

              <p className="text-sage font-medium text-sm" data-id="element-153">
                Solo por 3 días · Oferta de lanzamiento
              </p>
            </div>

            {/* CTA Button — full width on mobile, vibrant orange */}
            <a href={checkoutUrl} onClick={trackCTAClick} className="block w-full mt-5 bg-[#E8763A] hover:bg-[#D4682F] text-white font-extrabold py-4 px-6 rounded-full transition-all transform hover:scale-[1.02] shadow-lg text-base md:text-lg text-center uppercase tracking-wide" data-id="element-154">
              SÍ, QUIERO EL PLAN POR SOLO $114 MXN
            </a>

            {/* Micro-text below CTA */}
            <p className="text-warm-gray text-xs mt-3 font-medium" data-id="element-155">
              Pago único • Descarga inmediata • Garantía 7 días
            </p>
            <p className="text-warm-gray/70 text-[11px] mt-2 leading-relaxed" data-id="element-156">
              🔒 Pago Seguro 100%. ¿Necesitas ayuda en México? 🇲🇽 Soporte
              oficial vía{' '}
              <a href="https://wa.me/16468066813?text=Hola%20Yenny,%20tengo%20una%20duda%20con%20el%20Plan%20Antiinflamatorio." target="_blank" rel="noopener noreferrer" className="text-[#25D366] font-semibold underline hover:text-[#1EBE5A]" data-id="element-157">
                WhatsApp
              </a>{' '}
              desde USA 🇺🇸
            </p>
          </div>
        </motion.div>

        {/* Image Content — desktop only */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative hidden lg:flex justify-center lg:justify-end" data-id="element-158">
          <div className="relative w-full max-w-lg" data-id="element-159">
            <div className="absolute inset-0 bg-sage/10 rounded-full blur-3xl transform scale-110 -z-10" data-id="element-160"></div>
            <img src="https://cdn.magicpatterns.com/uploads/2dDCDgq8yAYwtpqwYtng8M/mockup1.png" alt="Plan Antiinflamatorio Después de los 40 Ebook" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-161" />
          </div>
        </motion.div>
      </div>
    </section>;
}